<template>
    <div class="page-layout blank contacts-manage">
        <!-- <div v-if="ajaxCallinprogress" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div> -->
        <div class="d-flex justify-content-between align-items-center">
            <div class="breadcrumbactive mr-10">
                <div class="d-flex">
                    <span class="pointer">Notification</span>
                </div>
            </div>
            <!-- <input type="text" class="search-notifications-field" placeholder="Search by Ticket number" v-model="search_tickets"> -->
            <div class="d-flex">
                <date-picker v-model="dateRange" format="MM/DD/YYYY" :show-second="false" range class="filter-ms filterdate mr-1" onkeypress="return event.charCode >= 47 && event.charCode <= 57" :editable="true"
                    lang="en" @change="FormatDT" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date" placeholder="Select Date Range : mm/dd/yyyy - mm/dd/yyyy">
                </date-picker>
                <i class="icon icon-close text-danger pointer" @click="clearFilter" v-if="dateRange.length > 0" style="position:absolute;right:40px;top:17px"></i>
                <div class="bg-secondary d-flex align-items-center justify-content-center calender-logo-custom">
                    <img src="/static/images/blue-calendar-new.svg" alt="">
                </div>
            </div>
        </div>
        <div class="create-company-container w-100">
            <div class="main-div">
                <div class="create-company-header d-flex align-items-center justify-content-between">
                    <span class="fs-14  pl-4 text-white ml-1 fw-500">Notification list</span>
                    <!-- <button @click="scrollDown">scrollDown</button> -->
                </div>
                <div class="d-flex flex-col flex-auto min-h-0 relative z-10">
                    <div class="notifyPageSimple-scroll-content notifyBlock">
                        <div class="d-flex flex-auto flex-col z-10 h-full">
                            <div class="notifyPageSimple-wrapper">
                                <div class="notifyPageSimple-sidebarWrapper permanent closed notifyPageSimple-leftSidebar notifyFlexAuto">
                                    <div class="notifyPageSimple-sidebar border-0 permanent notifyDiv">
                                        <div class="notifyScroll">
                                            <div class="notifyPageSimple-sidebarContent">
                                                <div class="d-flex flex-col flex-auto h-full px-4 justify-content-center align-items-center">
                                                    <div class="no-data pt-2 d-flex">
                                                        <img src="/static/images/new-theme2024/notification_illustrator.svg" width="180" class="h-auto img-responsive">
                                                    </div>
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <h3 class="mt-15 notification-text">Get updated with current progress in tickets!</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="notifyPageSimple-contentWrapper pt-7 py-2">
                                    <div class="notifyPageSimple-content container notifyScroll position-relative">
                                        <div class="notes-list p-4 w-100" style="border-radius: 10px;box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.41);background-color: #fff;">
                                            <div v-if="(ajaxCallinprogress && list.length == 0)" style="width:100%; height:100%;" class="d-flex justify-content-center align-items-center">
                                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                            <div v-else-if="(!ajaxCallinprogress && list.length == 0)" style="width:100%; height:100%;" class="d-flex justify-content-center align-items-center">
                                                <h6 class="fw-600">No Notifications Found</h6>
                                            </div>
                                            <ul v-else class="notes-scroller px-4 py-2" @scroll="infiniteScroll" id="scroller">
                                                <li class="note-box d-flex align-items-center w-100 p-2" :class="note.is_read ? 'checked' : ''" v-for="(note) in list" :key="note.notification_id" @click="showNotification(note._id,note.is_read,note.notification_id)">
                                                    <div>
                                                        <div style="height: 55px;width: 55px;border-radius: 100%;overflow:hidden" class="d-flex">
                                                            <img :src="note.profile_pic" v-if="note.profile_pic" :alt="note.message" class="margin-auto-img" width="40">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" v-else :alt="note.message" class="margin-auto-img" width="40">
                                                        </div>
                                                    </div>
                                                    <div class="ml-3">
                                                        <div class="fw-500 fs-14">{{note.message}}</div>
                                                        <div class="fs-12 pt-1" style="color: #707070">{{note.created_datetime}}</div>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div v-if="(ajaxCallinprogress && list.length > 0)" style="top:85%; left:45%;position:absolute" class="d-flex justify-content-center align-items-center">
                                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-if="display_filters" class="scm-filters fadeInDown overflow-visible" :class="{'fadeInUp':hide_filters == true}">
            <notifications-filter></notifications-filter>
        </div> -->
        <notification-view modal_name='notifications-view' v-if="show_notification" :notification_id="notification_id" @hideNotification="hideNotification"></notification-view>
    </div>
</template>

<script>
import VueBus from 'vue-bus';
import { HalfCircleSpinner } from "epic-spinners";
import {EventBus} from "../eventBus/nav-bar-event.js";
import notification from '../mixins/notification.js';
const NotificationView = () => import("./NotificationView");
const NotificationsFilter = () => import('./NotificationsFilter')
import moment from 'moment-timezone'
export default{
    mixins: [notification],
    data(){
        return {
            ajaxCallinprogress: false,
            notification_id: '',
            search_tickets: '',
            skip: 0,
            limit: 10,
            list: [],
            total: 0,
            count: 0,
            display_filters: false,
            show_notification: false,
            dateRange: [],
            temp_end_date: '',
            temp_start_date: '',
        }
    },
    components: {
        HalfCircleSpinner,
        NotificationsFilter,
        NotificationView,
        VueBus
    },
    methods: {
        clearFilter(){
            this.list = []
            this.dateRange = []
            this.count = 0
            this.getNotification();
        },
        convertTime12to24(time12h){
            const [time, modifier] = time12h.split(' ');
            let [hours, minutes] = time.split(':');
            if (hours === '12') {
                hours = '00';
            }
            if (modifier === 'PM') {
                hours = parseInt(hours, 10) + 12;
            }
            return `${hours}:${minutes}`;
        },
        FormatDT(){
            this.count = 0
            this.list = []
            this.dateRange.forEach((el, el_index) => {
                if(el_index == 1){
                    this.temp_end_date = moment(el, 'MM/DD/YYYY').format("DD-MM-YYYY")
                } else {
                    this.temp_start_date = moment(el, 'MM/DD/YYYY').format("DD-MM-YYYY")
                }
            })
            this.getNotification();
        },
        async getNotification(){
            try {
                this.ajaxCallinprogress = true
                let params ={
                    skip: this.count,
                    limit: this.limit,
                    search_key:this.search_tickets,
                    date_range: {
                        created_date: [],
                        modification_date: []
                    }
                }
                if(this.dateRange.length > 0){
                    params.date_range['created_date'] = [this.temp_start_date, this.temp_end_date]
                }
                let res = await this.getNotificationList(params)
                this.list = res.response.notifications
                this.list.forEach((x) => {
                    if(x.hasOwnProperty('created_time')){
                        x.created_to_array = x.created_time.split(',')
                        x['time']= x.created_to_array[1].trim()
                        x['date']= x.created_to_array[0]
                        x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | hh:mm A")
                    }
                })
                this.total = res.response.count
                this.count = this.list.length
                this.ajaxCallinprogress = false
            } catch (reason) {
                console.log(reason)
            }
        },
        async infiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    this.ajaxCallinprogress = true
                    let params = {
                        skip: this.count,
                        limit: this.limit,
                        search_key:this.search_tickets,
                        date_range: {
                            created_date: [],
                            modification_date: []
                        }
                    }
                    if(this.dateRange.length > 0){
                        params.date_range['created_date'] = [this.temp_start_date, this.temp_end_date]
                        params.date_range['modification_date'] = []
                    }
                    let response = await this.getNotificationList(params)
                    if (response.response.skip == this.count) {
                        let tempFiles = response.response.notifications
                        tempFiles.forEach(el => {
                            this.list.push(el)
                        })
                        this.list.forEach((x) => {
                            if(x.hasOwnProperty('created_time')){
                                x.created_to_array = x.created_time.split(',')
                                x['time']= x.created_to_array[1].trim()
                                x['date']= x.created_to_array[0]
                                x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | hh:mm A")
                            }
                        })
                        this.list = this.list.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.list.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.count += response.response.notifications.length
                        this.ajaxCallinprogress = false
                    }
                } catch (reason) {
                    console.log(reason)
                }
            }
        },
        async showNotification(id,i,notification_id) {
            this.$router.push({
                path: '/notifications_page',
                query: {
                    id: id,
                    is_read: i
                }
            })
            if(i == false){
                let res = await this.ChangeReadStatus({
                    notifications: [id]
                })
                EventBus.$emit('updateNotificationRead')
            }
            this.show_notification = true;
            this.notification_id = notification_id;
            setTimeout(() => {
                this.$modal.show('notifications-view');
            }, 500);
        },
        openFilterPopup(){
            this.display_filters = true
        },
        hideNotification() {
            this.show_notification = false;
            this.count = 0
            this.getNotification()
        },
    },
    async mounted(){
        this.getNotification()
        if(this.$route.query.id){
            if(this.$route.query.is_read == 'false'){
                await this.ChangeReadStatus({
                    notifications: [this.$route.query.id]
                })
            }
            this.show_notification = true;
            this.notification_id = this.$route.query.id;
            setTimeout(() => {
                this.$modal.show('notifications-view');
            }, 500);
        }
        EventBus.$on('RecallFBNotification', () => {
            this.getNotification()
        })
        EventBus.$on('updateMarkAllRead', () => {
            this.getNotification()
        })
        this.$bus.on('updateMarkAllRead', () => {
            this.getNotification()
        })
    },
    computed: {

    },
    watch:{
        '$route.query': async function(params) {
            if(this.$route.query.id){
                if(this.$route.query.is_read == 'false'){
                    await this.ChangeReadStatus({
                        notifications: [this.$route.query.id]
                    })
                }
                this.show_notification = true;
                this.notification_id = this.$route.query.id;
                setTimeout(() => {
                    this.$modal.show('notifications-view');
                }, 500);
            }
        }
    }
}
</script>

<style scoped>
    .h-auto{
        height: auto;;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 20px;
        margin-bottom: 50px;
    }
    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .lead-aside {
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        max-height:450px!important;
        overflow:scroll
    }

    .timeline {
        border-left: 2px solid #00448b;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        background: rgba(255, 255, 255, 0.03);
        color: rgba(255, 255, 255, 0.8);
        padding: 30px 48px 8px 0px !important;
        position: relative;
        line-height: 1.4em;
        overflow-x: initial;
        font-size: 14px;
        list-style: none;
        text-align: left;
        font-weight: 100;
        margin-left: 70px !important;
    }

    .timeline h3 {
        color: #303031 !important;
    }

    .timeline p {
        color: #303031 !important;
    }

    .timeline h1 {
        font-weight: 100;
        font-size: 1.4em;
    }

    .timeline h2,
    .timeline h3 {
        font-weight: 400;
        font-size: 16px;
    }

    .timeline .event {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        padding-bottom: 25px;
        margin-bottom: 25px;
        position: relative;
    }

    .timeline .event:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }

    .timeline .event:before,
    .timeline .event:after {
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event:before {
        left: -217.5px;
        color: #303031 !important;
        content: attr(data-date);
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
    }

    .timeline .event:after {
        left: -22.6px;
        background: #ffffff;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        content: "";
        top: 5px;
        border: 8px solid #00448b;
        box-shadow: 0 0 5px 0 #71acff;
    }

    .timeline .event-completed:after {
        font-family: 'fuse-iconfont';
        left: -22.6px;
        background: #34ac3d !important;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        content: "\ea7b";
        color: #fff;
        padding-top: 5px;
        font-size: 28px;
        top: 5px;
        border: 6px solid #34ac3d !important;
        box-shadow: 0 0 5px 0 #34ac3d !important;
    }

    .timeline .event .today-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event .date-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 19px;
    }
    .lead-status {
        box-shadow: 0 0 10px 0 #ededed;
        background-color: #fff;
        border-radius: 6px;
        width: 260px;
        height: auto;
        margin-left: 35px;
        border: solid 1px transparent;
    }
    .overflowing-broken-text{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .lead-time {
        color: #837e7e;
        font-weight: 500;
    }
    .notification-illustrator{
        width:30%;
        min-width: 420px !important;
        height: 500px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    .notification-illustrator h3{
        font-size: 25px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 1.63px;
        text-align: center;
        color: rgba(0, 0, 0, 0.71);
    }
    /* .notes-list{
        width:70% !important;
        min-width:920px;
        position: relative;
    } */
    .note-box{
        box-shadow: 0 0 #0000, 0 0 #0000,0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06);
        border-radius: 8px;
        background-color: #ededed !important;
        margin-bottom:20px;
        cursor: pointer;
    }
    .note-box.checked{
        background-color: #fff !important;
        box-shadow: 0 0 20px 0 #e1e7ee !important;
    }
    .notes-scroller{
        height:460px;
        overflow-y: auto;
        overflow-x: hidden
    }
    .overflow-x-auto{
        overflow-x: auto !important;
    }
    .pos-loader{
        position: absolute;
        top:85% !important;
        margin: 0 auto;
        left: 30%;
        right: 0;
    }
    .margin-auto-img{
        margin: auto;
        display: block;
    }

    .flex-auto {
    flex: 1 1 auto;
}
.min-h-0 {
    min-height: 0;
}
.z-10 {
    z-index: 10;
}
.relative {
    position: relative;
}
    .flex-col {
        flex-direction: column;
    }
    .notifyBlock {
        display: flex;
        flex-direction: column;
        min-width: 0px;
        min-height: 100%;
        position: relative;
        flex: 1 1 auto;
        width: 100%;
        height: auto;
        background-color: rgb(241, 245, 249);
    }
    .h-full {
        height: 100%;
    }
    .notifyBlock.notifyPageSimple-scroll-content {
        height: 100%;
    }.mx-datepicker-range {
    width: 369px;
    }


.notifyBlock .notifyPageSimple-wrapper {
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    z-index: 2;
    min-width: 0px;
    height: 100%;
    background-color: #fff;
    inset: 0px;
    overflow: hidden;
}
@media (min-width: 1200px) {
    .notifyFlexAuto {
        flex: 0 0 auto;
    }
    .notifyBlock .notifyPageSimple-sidebarWrapper {
        overflow: hidden;
        background-color: transparent;
        position: absolute;
    }
    .notifyBlock .notifyPageSimple-sidebar.permanent {
        position: relative;
    }
}
.notifyBlock .notifyPageSimple-sidebarWrapper.permanent {
    position: relative;
    margin-left: 0px;
    margin-right: 0px;
    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
}

.notifyBlock .notifyPageSimple-leftSidebar {
    border-left: 0px;
}
.notifyBlock .notifyPageSimple-leftSidebar {
    width: 400px;
}
.notifyBlock .notifyPageSimple-sidebar {
    position: absolute;
    background-color: rgb(255, 255, 255);
    color: rgb(17, 24, 39);
    max-width: 100%;
    height: 100%;
}
.notifyDiv {
    background-color: rgb(255, 255, 255);
    color: rgb(17, 24, 39);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: none;
    background-image: none;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1 0 auto;
    z-index: 1200;
    position: fixed;
    top: 0px;
    outline: 0px;
    left: 0px;
    border-right: 1px solid rgb(226, 232, 240);
}
.notifyScroll {
    overscroll-behavior: contain;
    min-height: 100%;
}
.notifyPageSimple-contentWrapper {
    display: flex;
    width: 100%;
    overflow: hidden;
}
.notifyPageSimple-contentWrapper .container {
    max-width: 1570px;
    width: 100%;
    margin: 0px auto;
}
.notifyPageSimple-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    height: 100%;
    align-items: flex-start;
    min-height: 0px;
}
.notifyPageSimple-sidebarContent {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
.notification-text {
    object-fit: contain;
    font-size: 15px;
    width:280px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    /* letter-spacing: 1.63px; */
    text-align: center;
    color: rgba(0, 0, 0, 0.71);
}
.calender-logo-custom{
    position: absolute;
    width: 38px;
    border-top-right-radius: 8px;
    height: 37px;
    right: 0px;
    border-bottom-right-radius: 8px;
}

@media (max-width: 900px) {
    .notifyBlock .notifyPageSimple-sidebar.permanent.closed {
        display: none;
    }
    .notifyBlock .notifyPageSimple-leftSidebar {
        width: 0px;
    }
}
</style>